import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {StoreModule} from '@ngrx/store';
import {entityIndicadoresFeatureKey, reducer} from './entity-indicador.reducer';


@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    StoreModule.forFeature(entityIndicadoresFeatureKey, reducer),
  ],
})
export class EntityIndicadorModule {
}
